module.exports = __webpack_public_path__ + "static/logdf-b8df567e369fdfa51faceadebc3960b5.png";